import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import ModelDialog from './ModelDialog';
import { Box, Button, CardMedia, DialogContent, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { QRCodeCanvas } from 'qrcode.react';
// import logo from './../../assets/clients/client.png'
import CloseIcon from '@mui/icons-material/Close';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useSendStoreLogs } from '../../hooks/StoreLogs/useSendStoreLogs';
import Share from './Share/Share';
import { shareWithNativeOrPopup } from '../../utils/nativeShare';
import { getStoreSettings } from '../../utils/saveStoreSettings';
import fasterLinkQrLogo from '../../assets/logos/Logo.svg';
import {
    downloadQrFromContainer,
    QR_SAVE_ERROR_AR,
    successMessageForSaveMode,
} from '../../utils/downloadQrImage';

/** Center Faster Link logo (~18% of QR canvas) — same for all stores */
const QR_CANVAS_SIZE = 150;
const QR_CENTER_LOGO_PX = Math.round(QR_CANVAS_SIZE * 0.18);
const FASTER_LINK_QR_IMAGE_SETTINGS = {
    src: fasterLinkQrLogo,
    width: QR_CENTER_LOGO_PX,
    height: QR_CENTER_LOGO_PX,
    excavate: true,
};

const ModelQrCode = ({ openDialog, setOpenDialog, data, slug }) => {
    const theme = useTheme();
    let store_setting = null;
    try {
        store_setting = slug ? getStoreSettings(slug) : null;
    } catch (_) {
        store_setting = null;
    }
    const identityColor =
        data?.identity_color ||
        store_setting?.identity_color ||
        theme.palette.nav?.btn ||
        theme.palette.primary.main;
    const { storeLogs: sendLogs, isPending } = useSendStoreLogs()
    const { t } = useTranslation()
    // let lng = i18next.language;
    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    const qrCardRef = useRef(null);
    const [isSaving, setIsSaving] = useState(false);

    const fallUrl = `https://fasterlink.me/${slug}`

    const downloadAsImage = async () => {
        const node = qrCardRef.current;
        if (!node || isSaving) return;

        setIsSaving(true);
        try {
            const filename = slug ? `${slug}-qr-code.png` : 'qr-code.png';
            const { mode } = await downloadQrFromContainer(node, filename);
            toast.success(successMessageForSaveMode(mode, 'ar'));
            sendLogs('download_the_qr_code');
        } catch (error) {
            if (error?.name === 'AbortError') {
                return;
            }
            console.error('خطأ في تحويل الصورة:', error);
            toast.error(QR_SAVE_ERROR_AR);
        } finally {
            setIsSaving(false);
        }
    };

    const shareAnchorRef = useRef(null);
    const [shareOpen, setShareOpen] = useState(false);

    const handleShareToggle = async () => {
        if (shareOpen) {
            setShareOpen(false);
            return;
        }
        const result = await shareWithNativeOrPopup({
            name: data?.name,
            url: fallUrl,
            openPopup: () => setShareOpen(true),
        });
        if (result === 'shared') sendLogs('shares');
    };

    const handleShareClose = () => {
        setShareOpen(false);
    };
    return (
        <>
            <ModelDialog openDialog={openDialog}
                handleClickOpenDialog={handleClickOpenDialog}
                setOpenDialog={setOpenDialog} >
                <DialogContent sx={{ padding: 0, backgroundColor: identityColor, pb: 1 }}>
                    {/* الهيدر الأبيض وزر الإغلاق */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            py: 1,
                            px: 2,
                        }}
                    >
                        <IconButton onClick={handleCloseDialog} sx={{ color: '#000' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* محتوى QR */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: identityColor,
                            pt: 8,
                            pb: 2,
                            px: 3,
                            borderRadius: 2,
                        }}>
                        <Box
                            ref={qrCardRef}
                            sx={{
                                display: 'flex',
                                flexDirection: { md: 'row', xs: 'column' },
                                alignItems: 'center',
                                gap: { md: 4, xs: 1 },
                                backgroundColor: '#fff',
                                padding: 3,
                                borderRadius: 2,
                                width: '100%',
                                position: 'relative',
                                textAlign: 'center',
                                justifyContent: 'center'
                            }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}>
                                {data?.logo &&
                                    <CardMedia
                                        image={data?.logo}
                                        className="test"
                                        alt="Logo"
                                        sx={{
                                            width: 80,
                                            height: 80,
                                            borderRadius: '50%',
                                            position: { md: 'relative', xs: 'absolute' },
                                            top: '-20%',
                                        }}
                                    />}
                                <Box my={1}>
                                    <Typography variant="h6" sx={{
                                        // color: '#000', margin: 0,
                                        // fontFamily: 'URW DIN Arabic, sans-serif',
                                        // fontWeight: 'medium',
                                        // fontSize: 20,
                                        // direction: 'rtl',
                                        // textRendering: 'optimizeLegibility'
                                        color: '#000',
                                        margin: 0,
                                        fontFamily: '"URW DIN Arabic", sans-serif',
                                        fontWeight: 'medium',
                                        fontSize: 20,
                                        direction: 'rtl',
                                        textAlign: 'right',
                                        letterSpacing: 0, // مهم جدًا للنص العربي
                                        WebkitFontSmoothing: 'antialiased', // تحسين العرض في iOS
                                        textRendering: 'geometricPrecision',
                                        whiteSpace: 'nowrap', // لمنع التقطيع
                                    }}>
                                        {/* {data?.name} */}
                                        {data?.name}

                                    </Typography>
                                </Box>
                            </Box>
                            <QRCodeCanvas
                                value={fallUrl}
                                size={QR_CANVAS_SIZE}
                                bgColor={"#ffffff"}
                                fgColor="#000000"
                                level="H"
                                imageSettings={FASTER_LINK_QR_IMAGE_SETTINGS}
                            />
                        </Box>
                    </Box>
                    <Box display="flex" gap={2} my={2} sx={{ justifyContent: 'center', }}>
                        <Button
                            variant="contained"
                            onClick={downloadAsImage}
                            disabled={isPending || isSaving}
                            sx={{
                                backgroundColor: '#fff',
                                color: identityColor,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                '&:hover': { backgroundColor: '#eee' },
                                flexDirection: 'column',
                                width: '100px'
                            }}
                        >
                            <ArrowDownwardIcon sx={{ fontSize: 'large' }} />
                            {t('globalSetting.save')}
                        </Button>
                        <Button
                            variant="contained"
                            disabled={isPending || isSaving}
                            onClick={handleShareToggle}
                            sx={{
                                backgroundColor: '#fff',
                                color: identityColor,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                '&:hover': { backgroundColor: '#eee' },
                                flexDirection: 'column',
                                width: '100px'
                            }}
                            ref={shareAnchorRef}>
                            <ArrowUpwardIcon sx={{ fontSize: 'large' }} />
                            {t('sheer')}
                        </Button>
                        <Share anchorEl={shareAnchorRef.current}
                            open={shareOpen}
                            onClose={handleShareClose}
                            main_url={fallUrl}
                            name={data?.name} />
                    </Box>
                    <Typography sx={{ color: theme.palette.primary.text, margin: '8px 0', textAlign: 'center', fontFamily: 'URW DIN Arabic', fontWeight: 'medium', fontSize: 14, lineHeight: '24px' }}>{t('supporter')}</Typography>
                </DialogContent>
            </ModelDialog>
        </>
    )
}

export default ModelQrCode